import { render } from "./AddVehicleModal2.vue?vue&type=template&id=5028c12c&scoped=true"
import script from "./AddVehicleModal2.vue?vue&type=script&lang=js"
export * from "./AddVehicleModal2.vue?vue&type=script&lang=js"

import "./AddVehicleModal2.vue?vue&type=style&index=0&id=5028c12c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5028c12c"]])

export default __exports__